import { render } from "./AgentsPerformanceOverview.vue?vue&type=template&id=db74f26c&ts=true"
import script from "./AgentsPerformanceOverview.vue?vue&type=script&lang=ts"
export * from "./AgentsPerformanceOverview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__